import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "./shared/design/globals.css";
import { start } from "./app/boot";

start();
